module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('h1', [_vm._v("Usuários")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btn-add-request-type",
      "to": {
        name: 'UserImport'
      },
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Adicionar Usuários\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perPage),
      expression: "perPage"
    }],
    staticClass: "input-sm",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.perPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getUsers]
    }
  }, [_c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 15
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite e pressione Enter"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUsers.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "items": _vm.users,
      "fields": _vm.fields,
      "striped": "",
      "hover": ""
    }
  }), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": _vm.count,
      "per-page": _vm.perPage
    },
    on: {
      "input": _vm.getUsers
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7995ef9e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserList.vue
// module id = 1462
// module chunks = 1